var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecor4X4Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 119,
    viewBox: "0 0 120 119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-91 -2155)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(91 2155)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(91 2189)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(91 2224)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(91 2259)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(126 2155)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(126 2189)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(126 2224)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(126 2259)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(161 2155)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(161 2189)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(161 2224)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(161 2259)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(196 2155)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(196 2189)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(196 2224)",
    fill: "#0533b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(196 2259)",
    fill: "#0533b3",
    opacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor4X4Blue);
export default __webpack_public_path__ + "static/media/decor-4x4-blue.ca88803ddc04e7170887d6dfe8c04caf.svg";
export { ForwardRef as ReactComponent };